// extracted by mini-css-extract-plugin
module.exports = {"qrCode":"styles_qrCode__2oChs"};